module.exports = __webpack_public_path__ + "img/slika_prva.jpg";